import { WebSpeechTtsService } from './WebSpeechTtsService';
import { AzureTtsService } from './AzureTtsService';

class TtsFactory {
  constructor() {
    this.services = {
      'web-speech': new WebSpeechTtsService(),
      'azure': new AzureTtsService(),
    };
  }

  /**
   * Get the TTS service based on provider name
   * @param {string} provider 
   * @returns {TtsService}
   */
  getService(provider) {
    const service = this.services[provider];
    if (!service) {
      console.warn(`TTS Provider ${provider} not found, falling back to Web Speech`);
      return this.services['web-speech'];
    }
    return service;
  }
}

export const ttsFactory = new TtsFactory();
